export interface ExperienceCriteriaScoreRecalculationStatusResponse {
    isCompleted: boolean;
}

const DefaultExperienceCriteriaScoreRecalculationStatusResponse: ExperienceCriteriaScoreRecalculationStatusResponse = {
    isCompleted: false,
};

export { DefaultExperienceCriteriaScoreRecalculationStatusResponse };
